import { render, staticRenderFns } from "./FacetGroup.vue?vue&type=template&id=47436fe0&scoped=true"
import script from "./FacetGroup.vue?vue&type=script&lang=js"
export * from "./FacetGroup.vue?vue&type=script&lang=js"
import style0 from "./FacetGroup.vue?vue&type=style&index=0&id=47436fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47436fe0",
  null
  
)

export default component.exports